import React, { useState } from 'react'
import * as Yup from 'yup';
import dynamic from 'next/dynamic'


const BorderBtn = dynamic(() => import('../../Common/BorderBtn', { ssr: false }));

export default function EnquireNow({sampleSlug}) {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const fieldsEnquiryPriceForm = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().required('Name is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'Add Your Company E-mail Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12'

        },
    ];
    return (
        <div>
            <BorderBtn
                customClass='w-full flex flex-start px-4 py-2 font-semibold hightLightBtn1 text-white justify-center text-sm mt-2 rounded hover:bg-[#0c4ad9]'
                buttonTitle='Enquire for Discounted Pricing'
                form_name="price-enquiry"
                formTitle="Enquire for Discounted Pricing"
                customFields={fieldsEnquiryPriceForm}
                endpoint="/enquiry/report-store-form"
                onclick={openModal}
                product_name ={sampleSlug}
            />
        </div>
    )
}